import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2 } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section className="px-5 md:px-8 py-20 md:py-32 bg-[#E63946] text-[#FFF4E6] relative overflow-hidden noise">
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#FFD84D]/30" />
      <div className="absolute -bottom-16 -left-16 w-60 h-60 rounded-full bg-[#1a1a1a]/20" />
      <div className="max-w-6xl mx-auto text-center relative">
        <h2 className="font-display text-6xl md:text-9xl uppercase leading-[0.85]">
          Ready to<br />crunch <span className="italic">different?</span>
        </h2>
        <p className="font-brico text-xl mt-6 opacity-90">Top 5 players win a real TruCrunch hamper.</p>
        <p className="font-brico text-lg opacity-80">Snacks in the kitchen. Fun on the screen.</p>
        <Link to="/play" className="btn-chunky mt-8 bg-[#FFF4E6] !text-[#1a1a1a] hover:bg-[#1a1a1a] hover:!text-[#FFF4E6]" style={{ background: '#FFF4E6', color: '#1a1a1a' }}>
          <Gamepad2 size={18} /> Play the Game
        </Link>
      </div>
    </section>
  );
};

export default FinalCTA;
